import { Container, Stack, Text } from '@mantine/core';
import PageHeader from '@components/shared/PageHeader';

export default function AppPlaygroundComingSoon({ title }: { title: string }) {
  return (
    <Container size='xl' py='lg'>
      <Stack gap='lg'>
        <PageHeader
          title={title}
          breadcrumbs={[
            { label: 'Admin', href: '/admin' },
            {
              label: 'App Playground testing',
              href: '/admin/app-playground',
            },
            { label: title },
          ]}
          showBackButton
          backUrl='/admin/app-playground'
        />
        <Text c='dimmed'>
          Playground non ancora disponibile. Per ora funziona solo Exposure.
        </Text>
      </Stack>
    </Container>
  );
}
